/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */
import React, { useContext } from "react";

export interface IEditorUIContext {
	rootEl: React.MutableRefObject<HTMLElement>;
}

export const EditorUIContext = React.createContext<IEditorUIContext>(null);

export function useEditorUIContext(): IEditorUIContext {
	return useContext(EditorUIContext);
}

export const EditorUIContextProvider: React.FC<IEditorUIContext> = ({ children, ...value }) => {
	return <EditorUIContext.Provider value={value}>{children}</EditorUIContext.Provider>;
};
